import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logoImg from "../../../assets/images/branding/logo-torneiofacil.png";
import Button from "../../../components/atoms/button";
import Input from "../../../components/atoms/input";
import { Box, CircularProgress, Typography } from "@mui/material";

import Navbar from "../../../components/organisms/navbar";
import api from "../../../services/api";
import {
  AccountExists,
  Container,
  Content,
  FormContent,
  FormGroup,
  PageDescription,
  PageLogo,
  PageTitle,
  SectionBanner,
  SectionForm,
} from "./styles";
import Swal from "sweetalert2";

const PasswordRecovery: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    setLoading(true);
    api
      .post("/auth/password/recovery", {
        ...data,
      })
      .then((response) => {
        setLoading(false);

        if (!response.data.status) {
          const seconds_remaining = response.data.seconds_remaining;
          const email = response.data.email;
          // só abre o modal **se ainda tiver tempo**
          if (seconds_remaining > 0) {
            Swal.fire({
              title: "Email não enviado",
              html: `Solicitação de recuperação de senha recusada para o email <strong>${email}</strong> <br/> Aguarde <b>${seconds_remaining}</b> segundos para solicitar novamente.`,
              icon: "error",
              timer: seconds_remaining * 1000,
              timerProgressBar: true,
              showConfirmButton: false,
              didOpen: () => {
                const b = Swal.getHtmlContainer()?.querySelector("b");
                const timerInterval = setInterval(() => {
                  const current = Math.floor((Swal.getTimerLeft() ?? 0) / 1000);
                  if (b) b.textContent = `${current}`;
                }, 1000);
                Swal.stopTimer(); // pausa até que o modal renderize totalmente
                Swal.resumeTimer(); // então começa o contador
              },
            });

            return;
          }
        }

        const responseData = JSON.parse(response.config.data);
        const emailDomain = responseData.email.split("@")[1];
        Swal.fire({
          title: "Sucesso!",
          text: `${response.data.message}`,
          icon: "success",
          confirmButtonText: `Abrir e-mail para recuperar sua senha`,
          confirmButtonColor: "#373737",
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(`https://${emailDomain}`, "_blank");
            navigate("/login");
          }
        });
        toast.success(response.data.message);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({
          title: "Atenção!",
          text: `${error.response.data.message}`,
          icon: "error",
          confirmButtonColor: "#373737",
        });
        toast.error(error.response.data.message);
      });
  };

  return (
    <>
    <Navbar />
    <Container>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center", // centraliza horizontalmente
            alignItems: "center", // centraliza verticalmente
            backdropFilter: "blur(6px)", // 👈 aplica o blur no fundo
            backgroundColor: "rgba(255, 255, 255, 0.4)", // leve transparência
            zIndex: 2000, // garante que fica acima de tudo
            gap: 2,
          }}
        >
          <Typography
            sx={{ fontFamily: "Inter, sans-serif", fontSize: "1.1rem" }}
          >
            Aguarde, estamos enviando suas instruções...
          </Typography>

          <CircularProgress sx={{ color: "black" }} />
        </Box>
      )}

      <SectionForm>
        <Content>
          <Link to={"/"}>
            <PageLogo src={logoImg} />
          </Link>
          <PageTitle>Recuperar senha</PageTitle>
          <PageDescription>
            Bem-vindo ao torneio fácil. Recupere <br />a sua conta preenchendo
            os dados abaixo.
          </PageDescription>

          <FormContent onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Input
                label="E-mail"
                name="email"
                type="text"
                register={register}
                required
                hasError={!!errors.email}
                error="Este campo é obrigatório"
                transformToLowerCase={true}
                trim={true}
              />
            </FormGroup>
            <FormGroup>
              <Button type="submit" label="Enviar instruções" />
            </FormGroup>
            <FormGroup>
              <AccountExists href="/login">
                Já possui conta? Acesse aqui.
              </AccountExists>
            </FormGroup>
          </FormContent>
        </Content>
      </SectionForm>
      <SectionBanner></SectionBanner>
    </Container>
    </>
  );
};

export default PasswordRecovery;
